import { useLazyQuery, useMutation } from "@apollo/client/react"; import React, { useEffect, useMemo, useState } from 'react';

import { useDebounce } from '../../../../../hooks/useDebounce';
import { Chip, FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import { TextInput } from '../../../../../components/textInput/TextInput';
import DataGridGenerico from '../../../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../../../components/dataGrid/columnHelpers';
import { CustomDialog } from "../../../../../components/customDialog/CustomDialog";
import { RenderInputByTypeMobile } from '../../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { GET_PROFESIONALES_PAGINATED, adaptProfesional, adaptProfesionalesArray } from '../../../../../data/graphQL/queries/Contratos/DatosPrincipales/getAllProfesionales';
import { GET_PROFESIONALES_DERIVADOR_PAGINATED, adaptProfesionalDerivador, adaptProfesionalesDerivadorArray } from '../../../../../data/graphQL/queries/Contratos/DatosPrincipales/getAllProfesionalesDerivador';
import { GET_TIPO_PROFESIONAL_DERIVADOR, adaptTipoProfesionalDerivadorArray } from '../../../../../data/graphQL/queries/Contratos/DatosPrincipales/getTipoProfesionalDerivador';
import { GET_ORIGEN_MATRICULA_DERIVADOR, adaptOrigenMatriculaDerivadorArray } from '../../../../../data/graphQL/queries/Contratos/DatosPrincipales/getOrigenMatriculaDerivador';
import { VALIDATE_EXIST_MATRICULA_BY_ORIGEN } from '../../../../../data/graphQL/queries/Contratos/DatosPrincipales/existaMatriculaByOrigen';
import { CREATE_PROFESIONAL_DERIVADOR } from '../../../../../data/graphQL/mutations/Contratos/CreateProfesionalDerivador';
import { CustomButton } from '../../../../../components/customButton/CustomButton';
import toast from 'react-hot-toast';

const profesionalesColumns = [
  {
    field: 'codigoProfesional',
    headerName: 'Código Profesional',
    align: 'center',
    flex: 0.20
  },
  {
    field: 'tipoProfesional',
    headerName: 'Tipo de Profesional',
    headerAlign: 'left',
    flex: 0.20
  },
  {
    field: 'apellido',
    headerName: 'Apellido',
    headerAlign: 'left',
    align: 'left',
    flex: 0.30
  },
  {
    field: 'nombre',
    headerName: 'Nombre',
    headerAlign: 'left',
    align: 'left',
    flex: 0.30
  }];


const profesionalesDerivadoresColumns = [
  {
    field: 'codigoProfesional',
    headerName: 'Código Profesional',
    align: 'center',
    flex: 0.20
  },
  {
    field: 'tipoProfesional',
    headerName: 'Tipo de Profesional',
    flex: 0.20
  },
  {
    field: 'nombreyapellido',
    headerName: 'Nombre y Apellido',
    headerAlign: 'left',
    align: 'left',
    flex: 0.30
  },
  {
    field: 'matricula',
    headerName: 'Matrícula',
    headerAlign: 'right',
    align: 'right',
    flex: 0.30
  }];


const optionsCombo = [
  { id: 'DE', displayName: "Profesionales Internos" },
  { id: 'NU', displayName: "Profesionales Externos" }];


const inputCombo = {
  displayName: 'Tipo de profesional',
  name: 'tipoDerivador',
  type: 'select',
  options: optionsCombo,
  col: 20
};

export const DerivadoInput = ({
  input,
  value,
  setDerivador,
  handleChange,
  idDelegacion,
  idDerivador,
  idDerivadorExterno,
  tipoDerivador
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [optionSelected, setOptionSelected] = useState(tipoDerivador);
  const [isProfesionalDerivadorExterno, setIsProfesionalDerivadorExterno] = useState(tipoDerivador === 'NU');
  const [profesionalSelected, setProfesionalSelected] = useState(null);

  const [openModalNuevo, setOpenModalNuevo] = useState(false);
  const [tiposProfesional, setTiposProfesional] = useState([]);
  const [origenesMatricula, setOrigenesMatricula] = useState([]);
  const initialNuevoProfesional = {
    nombre: '',
    apellido: '',
    idTipoProfesional: '',
    matriculas: []
  };
  const [nuevoProfesional, setNuevoProfesional] = useState(initialNuevoProfesional);
  const [matriculasSeleccionadas, setMatriculasSeleccionadas] = useState([]);
  const initialNuevaMatricula = {
    idOrigenMatricula: 0,
    numero: ''
  };
  const [nuevaMatricula, setNuevaMatricula] = useState(initialNuevaMatricula);
  const [
    profesionalesRows,
    setPaginationStatus,
    paginationStatus,
    totalCount,
    filterStatus,
    setFilterStatus] =
    useGetProfesionales(idDelegacion, idDerivador, setDerivador);

  const [
    derivadorRows,
    setDerivadorPaginationStatus,
    derivadorPaginationStatus,
    derivadorTotalCount,
    derivadorFilterStatus,
    setDerivadorFilterStatus] =
    useGetProfesionalesDerivador(idDelegacion, idDerivadorExterno, setDerivador);

  const columns = useMemo(() => generateColumnsDefaultConfiguration(profesionalesColumns), [profesionalesColumns]);
  const columnsDerivadores = useMemo(() => generateColumnsDefaultConfiguration(profesionalesDerivadoresColumns), [profesionalesDerivadoresColumns]);

  const handleOpenModal = () => {
    setFilterStatus('');
    setDerivadorFilterStatus('');
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  useEffect(() => { setOptionSelected(tipoDerivador); }, [tipoDerivador]);

  useEffect(() => {
    if (!!profesionalSelected) {
      const nombre = profesionalSelected.nombre || '';
      const apellido = profesionalSelected.apellido || '';
      const valueAux = `${profesionalSelected.tipoProfesional || ''}-${nombre} ${apellido}`.trim();
      setDerivador(valueAux);
      handleChange("tipoDerivador", optionSelected);
    }
  }, [profesionalSelected]);

  const handleRowClick = (row) => {
    setProfesionalSelected(row.row);
    if (isProfesionalDerivadorExterno) {
      handleChange('idDerivador', null);
      handleChange('idDerivadorExterno', row.row.codigoProfesional);
    } else {
      handleChange('idDerivadorExterno', null);
      handleChange('idDerivador', row.row.codigoProfesional);
    }
  };

  const handleChangeCombo = (name, value) => {
    setOptionSelected(value);
    setIsProfesionalDerivadorExterno(value === 'NU');
  };

  // NUEVO PROFESIONAL EXTERNO
  const [getTiposProfesionales, { data: dataTiposProfesionales, loading: tiposProfesionalesLoading }] = useLazyQuery(GET_TIPO_PROFESIONAL_DERIVADOR, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataTiposProfesionales) return;
    if (dataTiposProfesionales.tiposProfesionalDerivador.length > 0) {
      setTiposProfesional(adaptTipoProfesionalDerivadorArray(dataTiposProfesionales.tiposProfesionalDerivador));
    };
  }, [dataTiposProfesionales]);

  const [getorigenesMatriculas, { data: dataOrigenesMatriculas, loading: origenesMatriculasLoading }] = useLazyQuery(GET_ORIGEN_MATRICULA_DERIVADOR, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataOrigenesMatriculas) return;
    if (dataOrigenesMatriculas.allOrigenMatricula.length > 0) {
      setOrigenesMatricula(adaptOrigenMatriculaDerivadorArray(dataOrigenesMatriculas.allOrigenMatricula));
    };
  }, [dataOrigenesMatriculas]);

  const handleOpenNuevo = () => {
    getTiposProfesionales();
    getorigenesMatriculas();
    limpiarDlgNuevo();
    setOpenModalNuevo(true);
  };

  const limpiarDlgNuevo = () => {
    setNuevoProfesional(initialNuevoProfesional);
    setMatriculasSeleccionadas([]);
  };

  const handleCloseNuevo = () => {
    setOpenModalNuevo(false);
  };

  const handleChangeNuevaMatricula = (e) => {
    const { value, name } = e.target;
    setNuevaMatricula((previousData) => ({
      ...previousData,
      [name]: value
    }));
  };

  const validarNuevaMatricula = () => {
    // origen obligatorio
    if (nuevaMatricula?.idOrigenMatricula <= 0) {
      toast.error("El origen de la matrícula es obligatorio.");
      return false;
    }

    // número obligatorio
    if (nuevaMatricula?.numero <= 0) {
      toast.error("El número de la matrícula es obligatorio.");
      return false;
    }

    // que ya no esté agregado el origen
    const nodo = matriculasSeleccionadas.filter((m) => m.idOrigenMatricula == nuevaMatricula?.idOrigenMatricula);
    if (nodo.length > 0) {
      toast.error("El Origen de la matrícula ya se encuentra ingresado.");
      return false;
    }

    return true;
  };

  const [validarNuevaMatriculaUnicidad, { data: dataNuevaMatricula, loading: validarMatriculaLoading }] = useLazyQuery(VALIDATE_EXIST_MATRICULA_BY_ORIGEN, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataNuevaMatricula) return;
    if (!dataNuevaMatricula.existeMatriculaByOrigen) {
      // descripción del origen
      const nodoOrigen = origenesMatricula.filter((o) => o.id == nuevaMatricula?.idOrigenMatricula)[0];
      setMatriculasSeleccionadas((prevData) => {
        return [
          ...prevData,
          {
            idOrigenMatricula: nuevaMatricula?.idOrigenMatricula,
            origen: nodoOrigen.displayName,
            numero: nuevaMatricula?.numero
          }];

      });

      setNuevaMatricula(initialNuevaMatricula);
    } else {
      toast.error("El origen y el número de matrícula ya existe para otro profesional.");
    }
  }, [dataNuevaMatricula]);

  const handleClickAgregarMatricula = () => {
    if (validarNuevaMatricula()) {
      validarNuevaMatriculaUnicidad({ variables: { idOrigenMatricula: nuevaMatricula?.idOrigenMatricula, numero: nuevaMatricula?.numero } });
    }
  };

  const handleChangeNuevoProfesional = (e) => {
    const { value, name } = e.target;
    setNuevoProfesional((previousData) => ({
      ...previousData,
      [name]: value
    }));
  };

  const handleDeleteMatricula = (matricula) => {
    setMatriculasSeleccionadas(
      matriculasSeleccionadas?.filter((d) => d.idOrigenMatricula !== matricula.idOrigenMatricula)
    );
  };

  const validarNuevoProfesional = () => {
    if (nuevoProfesional.nombre.trim() == "") {
      toast.error("El Nombre del profesional es obligatorio");
      return false;
    }

    if (nuevoProfesional.apellido.trim() == "") {
      toast.error("El Apellido del profesional es obligatorio");
      return false;
    }

    if (nuevoProfesional.idTipoProfesional <= 0) {
      toast.error("El Tipo del profesional es obligatorio");
      return false;
    }

    if (matriculasSeleccionadas.length == 0) {
      toast.error("Al menos una matrícula debe ser ingresada para el profesional");
      return false;
    }

    return true;
  };

  const [createProfesionalDerivador] = useMutation(CREATE_PROFESIONAL_DERIVADOR);

  const handleSaveNuevo = () => {
    if (validarNuevoProfesional()) {
      createProfesionalDerivador({
        variables: {
          input: {
            apellido: nuevoProfesional?.apellido,
            nombre: nuevoProfesional?.nombre,
            idTipoProfesional: nuevoProfesional?.idTipoProfesional,
            matriculas: matriculasSeleccionadas
          }
        }
      }).
        then((res) => {
          if (res.data.createProfesionalDerivadorFull.success) {
            if (parseInt(res.data.createProfesionalDerivadorFull.valorEsperado, 10) > 0) {
              toast.success("Profesional externo guardado correctamente.");
              setOpenModalNuevo(false);
              const nodoTipoProfesional = tiposProfesional.filter((t) => t.id == nuevoProfesional?.idTipoProfesional)[0];
              handleRowClick({
                row: {
                  apellido: nuevoProfesional?.apellido.trim().toUpperCase(),
                  codigoProfesional: parseInt(res.data.createProfesionalDerivadorFull.valorEsperado, 10),
                  id: 0, // orden en la grilla, en este caso 0
                  nombre: nuevoProfesional?.nombre.trim().toUpperCase(),
                  tipoProfesional: nodoTipoProfesional.displayName
                }
              });
              handleClose();
            } else {
              toast.error(res.data.createProfesionalDerivadorFull.error);
            }
          } else {
            toast.error('Error al guardar el nuevo profesional externo 1.');
          }
        }).
        catch(() => {
          toast.error('Error al guardar el nuevo profesional externo 2.');
        });
    }
  };

  return <>
    <Grid size={{ xs: 100, sm: 50, md: input.col, lg: input.col }}>
      <TextInput
        label={input.displayName}
        variant={'outlined'}
        name={input.name}
        required={input.required}
        // onChange={} e => handleChange(e.target.name, e.target.value),
        onClick={() => handleOpenModal()}
        disabled={input.disabled}
        placeholder='Buscar'
        value={value}
        key={value}
        searchIcon
        shrink='true' />

    </Grid>
    <CustomDialog
      maxWidth='md'
      fullWidth
      onCancel={handleClose}
      open={openModal}
      cancelText='Cerrar'
      title='Profesional de cabecera'>

      <Grid
        container
        justifyContent={'flex-start'}
        gap={2}>

        <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
          <RenderInputByTypeMobile
            handleChange={handleChangeCombo}
            input={inputCombo}
            value={optionSelected} />

        </Grid>
        {(optionSelected === 'DE' || optionSelected === 'NU') && <>
          <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
            <TextInput
              placeholder='Filtrar'
              value={isProfesionalDerivadorExterno ? derivadorFilterStatus : filterStatus}
              searchIcon
              onChange={(e) => isProfesionalDerivadorExterno ? setDerivadorFilterStatus(e.target.value) : setFilterStatus(e.target.value)}
              onClearButtonClick={() => isProfesionalDerivadorExterno ? setDerivadorFilterStatus('') : setFilterStatus('')} />

          </Grid>
          {optionSelected === 'NU' && <Grid size={{ xs: 12, sm: 12, md: 1, lg: 1 }}>
            <CustomButton
              onClick={handleOpenNuevo}>

              Nuevo
            </CustomButton>
          </Grid>}
          <Grid size={{ xs: 12 }}>
            <DataGridGenerico
              hideFooterPagination={false}
              toolbar={false}
              columns={isProfesionalDerivadorExterno ? columnsDerivadores : columns}
              rows={isProfesionalDerivadorExterno ? derivadorRows : profesionalesRows}
              onPageChange={(page) =>
                isProfesionalDerivadorExterno ?
                  setDerivadorPaginationStatus((prev) => ({
                    ...prev,
                    page: page
                  })) :

                  setPaginationStatus((prev) => ({
                    ...prev,
                    page: page
                  }))
              }
              onPageSizeChange={(pageSize) =>
                isProfesionalDerivadorExterno ?
                  setDerivadorPaginationStatus((prev) => ({
                    ...prev,
                    pageSize: pageSize,
                    page: 0
                  })) :

                  setPaginationStatus((prev) => ({
                    ...prev,
                    pageSize: pageSize,
                    page: 0
                  }))
              }
              pageSize={isProfesionalDerivadorExterno ? derivadorPaginationStatus.pageSize : paginationStatus.pageSize}
              totalCount={isProfesionalDerivadorExterno ? derivadorTotalCount : totalCount}
              currentPage={isProfesionalDerivadorExterno ? derivadorPaginationStatus.page : paginationStatus.page}
              onRowClick={(row) => {
                handleRowClick(row);
                handleClose();
              }} />

          </Grid>
        </>}
      </Grid>
    </CustomDialog>
    <CustomDialog
      maxWidth='md'
      fullWidth
      open={openModalNuevo}
      onAccept={handleSaveNuevo}
      onCancel={handleCloseNuevo}
      acceptText='Guardar'
      cancelText='Cancelar'
      title='Profesional de cabecera'>

      <Grid
        container
        justifyContent={'flex-start'}
        gap={2}>

        <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
          <TextInput
            sx={{ backgroundColor: 'white', width: '100%' }}
            label="Nombre *"
            name="nombre"
            size="small"
            type="text"
            variant="outlined"
            onChange={handleChangeNuevoProfesional}
            value={nuevoProfesional?.nombre}
          />

        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
          <TextInput
            sx={{ backgroundColor: 'white', width: '100%' }}
            label="Apellido *"
            name="apellido"
            size="small"
            type="text"
            variant="outlined"
            onChange={handleChangeNuevoProfesional}
            value={nuevoProfesional?.apellido} />

        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 3, lg: 3 }}>
          <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
            <InputLabel id="select-tipo-prof-nuevo">Tipo de Profesional *</InputLabel>
            <Select
              labelId="select-tipo-prof-nuevo"
              label='Tipo de Profesional *'
              name='idTipoProfesional'
              onChange={handleChangeNuevoProfesional}
              options={tiposProfesional}
              value={nuevoProfesional?.idTipoProfesional}>

              {tiposProfesional && tiposProfesional.map((tipo) => {
                return <MenuItem value={tipo.id}>{tipo.displayName}</MenuItem>;
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
          <div style={{ fontWeight: 600, fontSize: '14px', borderTop: '1pt solid #BDBDBD', paddingTop: 15 }}>Matrícula</div>
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
          <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
            <InputLabel id="select-origen">Origen</InputLabel>
            <Select
              labelId="select-origen"
              label='Origen'
              onChange={handleChangeNuevaMatricula}
              name="idOrigenMatricula"
              options={origenesMatricula}
              value={nuevaMatricula?.idOrigenMatricula}>

              {origenesMatricula && origenesMatricula.map((origen) => {
                return <MenuItem value={origen.id}>{origen.displayName}</MenuItem>;
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid size={{ xs: 6, sm: 6, md: 3, lg: 3 }}>
          <TextInput
            sx={{ backgroundColor: 'white', width: '100%' }}
            label="Número"
            name="numero"
            size="small"
            type='number'
            variant="outlined"
            onChange={handleChangeNuevaMatricula}
            value={nuevaMatricula?.numero} />

        </Grid>
        <Grid size={{ xs: 6, sm: 6, md: 3, lg: 3 }}>
          <CustomButton
            onClick={handleClickAgregarMatricula}
            variant='outlined'
            isLoading={validarMatriculaLoading}>

            Agregar
          </CustomButton>
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
          {matriculasSeleccionadas?.map((matricula) => {
            return (
              <>
                <Chip
                  size='small'
                  label={matricula.origen + "-" + matricula.numero}
                  onDelete={() => {
                    handleDeleteMatricula(matricula);
                  }}
                  sx={{ Margin: '0 8px 8px 0' }} />

                &nbsp;&nbsp;
              </>);

          })}
        </Grid>
      </Grid>
    </CustomDialog>
  </>;
};

const useGetProfesionales = (idDelegacion, idDerivador, setDerivador) => {
  const [profesionales, setProfesionales] = useState([]);
  const adaptedProfesionales = useMemo(() => adaptProfesionalesArray(profesionales?.allProfesionalesPaginated?.items) || [], [profesionales]);

  const [paginationStatus, setPaginationStatus] = useState({
    pageSize: 5,
    page: 0
  });

  const [filterStatus, setFilterStatus] = useState('');
  const debouncedFilterValue = useDebounce(filterStatus, 1000);

  const [getProfesionales, { error: errorProfesionales, loading: profesionalesLoading }] = useLazyQuery(
    GET_PROFESIONALES_PAGINATED,
    {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  );

  const [getProfesionalDerivador] = useLazyQuery(
    GET_PROFESIONALES_PAGINATED,
    {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  );

  useEffect(() => {
    if (!idDerivador || idDerivador <= 0) return;

    getProfesionalDerivador({
      variables: {
        idDelegacion,
        skip: 0,
        take: 1,
        where: {
          idProfesional: { eq: idDerivador }
        }
      }
    })
      .then(({ data }) => {
        console.log(data)
        const items = data?.allProfesionalesPaginated?.items;
        if (Array.isArray(items) && items.length > 0) {
          const profesional = adaptProfesional(items[0]);
          setDerivador(
            `${profesional.tipoProfesional || ''}-${profesional.nombre || ''} ${profesional.apellido || ''}`.trim()
          );
        }
      }).catch((error) => {
        if (error?.name === "AbortError") return; // ignorar abortos
        console.log("Error en getProfesionales:", error);
      });

  }, [idDerivador]);

  useEffect(() => {
    if (errorProfesionales) {
      console.error("GRAPHQL ERROR:", errorProfesionales);
      toast.error("Error al consultar el nuevo profesional externo.");
    }
  }, [errorProfesionales]);

  // useEffect(() => {
  //   if (!idDerivador) return;

  //   const row = adaptedProfesionales.find((x) => x.codigoProfesional === idDerivador);
  //   if (!!row) {
  //     const newValue = `${row.tipoProfesional || ''}-${row.nombre || ''} ${row.apellido || ''}`.trim();
  //     setDerivador(newValue);
  //     return;
  //   }

  //   const getProfesionalSelected = async () => {
  //     if (!idDerivador || idDerivador <= 0) {
  //       console.log("Ignorando porque idDerivador no válido:", idDerivador);
  //       return;
  //     }

  //     try {
  //       const res = await getProfesionales({
  //         variables: {
  //           idDelegacion,
  //           skip: 0,
  //           take: 1,
  //           where: {
  //             idProfesional: { eq: idDerivador }
  //           }
  //         },
  //         fetchPolicy: "no-cache" // opcional
  //       });

  //       if (res?.errors?.length) throw res.errors;

  //       const items = res?.data?.allProfesionalesPaginated?.items ?? [];

  //       if (items.length > 0) {
  //         const profesional = adaptProfesional(items[0]);
  //         setDerivador(`${profesional.tipoProfesional || ''}-${profesional.nombre || ''} ${profesional.apellido || ''}`.trim());
  //       }

  //     } catch {
  //       toast.error('Error al consultar el nuevo profesional externo.');
  //     }
  //   };

  //   getProfesionalSelected();
  // }, [idDerivador]);

  useEffect(() => {
    if (!profesionalesLoading) {
      getProfesionales({
        variables: {
          skip: paginationStatus.page * paginationStatus.pageSize,
          take: paginationStatus.pageSize,
          where: {
            and: [
              idDelegacion !== null && idDelegacion !== undefined ? { t_ProfesionalDel: { some: { idDelegacion: { eq: idDelegacion } } } } : {},
              {
                or: [
                  { nombre: { contains: debouncedFilterValue?.trim() } },
                  { apellido: { contains: debouncedFilterValue?.trim() } },
                  { idTipoProfesionalNavigation: { or: { descripcion: { contains: debouncedFilterValue?.trim() } } } }]

              }]

          }
        }
      }).then((res) => {
        setProfesionales(res?.data);
      }).catch((error) => {
        if (error?.name === "AbortError") return; // ignorar abortos
        console.error("Error en getInstituciones:", error);
      });
    }
  }, [paginationStatus, debouncedFilterValue, idDelegacion]);

  return [
    adaptedProfesionales,
    setPaginationStatus,
    paginationStatus,
    profesionales?.allProfesionalesPaginated?.totalCount,
    filterStatus,
    setFilterStatus];

};

const useGetProfesionalesDerivador = (idDelegacion, idDerivadorExterno, setDerivador) => {
  const [profesionalesDerivador, setProfesionalesDerivador] = useState([]);
  const adaptedProfesionalesDerivador = useMemo(() => adaptProfesionalesDerivadorArray(profesionalesDerivador?.allProfesionalDerivador?.items) || [], [profesionalesDerivador]);

  const [paginationStatus, setPaginationStatus] = useState({
    pageSize: 5,
    page: 0
  });

  const [filterStatus, setFilterStatus] = useState('');
  const debouncedFilterValue = useDebounce(filterStatus, 1000);

  const [getProfesionalesDerivador, { loading: profesionalesDerivadorLoading }] = useLazyQuery(GET_PROFESIONALES_DERIVADOR_PAGINATED, {
    fetchPolicy: 'no-cache'
  });

  const [getProfesionalDerivadorById] = useLazyQuery(GET_PROFESIONALES_DERIVADOR_PAGINATED, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!idDerivadorExterno) return;

    const row = adaptedProfesionalesDerivador.find((x) => x.codigoProfesional === idDerivadorExterno);
    if (!!row) {
      const newValue = `${row.tipoProfesional || ''}-${row.nombreyapellido || ''}`.trim();
      setDerivador(newValue);
      return;
    }

    const getProfesionalSelected = async () => {
      const getNewProfesional = await getProfesionalDerivadorById({
        variables: {
          skip: 0,
          take: 1,
          where: {
            idProfesionalderivador: { eq: idDerivadorExterno }
          }
        }
      }).then((res) => {
        if (res?.data?.allProfesionalDerivador?.items !== null) {
          const profesional = adaptProfesionalDerivador(res?.data?.allProfesionalDerivador?.items[0]);
          const newValue = `${profesional.tipoProfesional || ''}-${profesional.nombreyapellido || ''}`.trim();
          setDerivador(newValue);
        }
      }).catch((error) => {
        if (error?.name === "AbortError") return; // ignorar abortos
        console.error("Error en getInstituciones:", error);
      });
    };
    getProfesionalSelected();
  }, [idDerivadorExterno]);

  useEffect(() => {
    if (!profesionalesDerivadorLoading) {
      getProfesionalesDerivador({
        variables: {
          skip: paginationStatus.page * paginationStatus.pageSize,
          take: paginationStatus.pageSize,
          where: {
            or: [
              // { idProfesionalderivador: { eq: parseInt(debouncedFilterValue, 10) } },
              { apellido: { contains: debouncedFilterValue?.trim() } },
              { nombre: { contains: debouncedFilterValue?.trim() } },
              { idTipoProfesionalNavigation: { or: { descripcion: { contains: debouncedFilterValue?.trim() } } } }]

          }
        }
      }).then((res) => {
        setProfesionalesDerivador(res?.data);
      }).catch((error) => {
        if (error?.name === "AbortError") return; // ignorar abortos
        console.error("Error en getInstituciones:", error);
      });
    }
  }, [paginationStatus, debouncedFilterValue, idDelegacion]);

  return [
    adaptedProfesionalesDerivador,
    setPaginationStatus,
    paginationStatus,
    profesionalesDerivador?.allProfesionalDerivador?.totalCount,
    filterStatus,
    setFilterStatus];

};